import howSwitchingWorksUrl from "./how-switching-works.md";
import rentInterruptionUrl from "./rent-interruption.md";
import urgentRepairsUrl from "./urgent-vs-non-urgent-repairs.md";
import pmLimitsUrl from "./what-property-managers-can-and-cannot-legally-do.md";
import minStandardsUrl from "./minimum-rental-standards-explained-victoria.md";
import trustAccountsUrl from "./how-trust-accounts-actually-work.md";
import arrearsProcessUrl from "./what-happens-when-a-tenant-stops-paying-rent.md";
import mythsRealityUrl from "./common-landlord-myths-vs-legal-reality-victoria.md";

export const insights = [
  {
    slug: "how-switching-works",
    title: "How Switching Property Managers Actually Works (Step by Step)",
    excerpt:
      "A practical overview of what happens behind the scenes when you move management to XLZ.",
    category: "Switching",
    date: "2026-01-18",
    url: howSwitchingWorksUrl,
  },

  {
    slug: "rent-interruption",
    title: "Will My Rent Be Interrupted If I Change Property Managers?",
    excerpt:
      "A clear explanation of how rent collection is handled during a management change — and why interruptions are uncommon when the process is planned properly.",
    category: "Switching",
    date: "2026-01-18",
    url: rentInterruptionUrl,
  },

  {
    slug: "urgent-vs-non-urgent-repairs",
    title: "Urgent vs Non-Urgent Repairs: What Owners Need to Know",
    excerpt:
      "An explanation of urgent and non-urgent repairs under Victorian rental law, and what owners are required to do when issues arise.",
    category: "Repairs & Compliance",
    date: "2026-01-18",
    url: urgentRepairsUrl,
  },

  {
    slug: "what-property-managers-can-and-cannot-legally-do",
    title: "What Property Managers Can and Cannot Legally Do",
    excerpt:
      "A clear explanation of the legal limits on property managers in Victoria — what they are authorised to do, and where owner consent is required.",
    category: "Management & Compliance",
    date: "2026-01-18",
    url: pmLimitsUrl,
  },

  {
    slug: "minimum-rental-standards-explained-victoria",
    title: "Minimum Rental Standards Explained (Victoria)",
    excerpt:
      "A clear explanation of Victoria’s minimum rental standards — what owners are legally responsible for and when standards apply.",
    category: "Compliance",
    date: "2026-01-18",
    url: minStandardsUrl,
  },

  {
    slug: "how-trust-accounts-actually-work",
    title: "How Trust Accounts Actually Work (Plain English)",
    excerpt:
      "A clear explanation of property management trust accounts — how rent is held, transferred, and reported, and what protections are built into the system.",
    category: "Finance & Trust Accounting",
    date: "2026-01-18",
    url: trustAccountsUrl,
  },

  {
    slug: "what-happens-when-a-tenant-stops-paying-rent",
    title: "What Happens When a Tenant Stops Paying Rent (Realistic Timelines)",
    excerpt:
      "A realistic explanation of rent arrears in Victoria — including legal steps, notice periods, and why timelines matter.",
    category: "Arrears & Compliance",
    date: "2026-01-18",
    url: arrearsProcessUrl,
  },

  {
    slug: "common-landlord-myths-vs-legal-reality-victoria",
    title: "Common Landlord Myths vs Legal Reality (Victoria)",
    excerpt:
      "A clear look at common assumptions landlords make — and how Victorian rental law and real-world practice actually work.",
    category: "Owners & Compliance",
    date: "2026-01-18",
    url: mythsRealityUrl,
  },

];
